/** Small corner label burned into downloads when the user opts in. */
export const AI_DISCLAIMER_TEXT = 'AI Enhanced';

/**
 * Draws a discreet "AI Enhanced" pill in the bottom-right corner.
 * Scales with image size so it stays readable but unobtrusive on listing photos.
 */
export function drawAiDisclaimer(
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  text: string = AI_DISCLAIMER_TEXT,
): void {
  const fontSize = Math.max(12, Math.round(Math.min(width, height) * 0.018));
  const paddingX = Math.round(fontSize * 0.75);
  const paddingY = Math.round(fontSize * 0.45);
  const margin = Math.round(fontSize * 1.1);

  ctx.save();
  ctx.font = `500 ${fontSize}px system-ui, -apple-system, BlinkMacSystemFont, sans-serif`;
  ctx.textBaseline = 'middle';
  ctx.textAlign = 'left';

  const textWidth = ctx.measureText(text).width;
  const boxW = textWidth + paddingX * 2;
  const boxH = fontSize + paddingY * 2;
  const x = width - margin - boxW;
  const y = height - margin - boxH;
  const radius = boxH / 2;

  ctx.fillStyle = 'rgba(0, 0, 0, 0.45)';
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.arcTo(x + boxW, y, x + boxW, y + boxH, radius);
  ctx.arcTo(x + boxW, y + boxH, x, y + boxH, radius);
  ctx.arcTo(x, y + boxH, x, y, radius);
  ctx.arcTo(x, y, x + boxW, y, radius);
  ctx.closePath();
  ctx.fill();

  ctx.fillStyle = 'rgba(255, 255, 255, 0.92)';
  ctx.fillText(text, x + paddingX, y + boxH / 2);
  ctx.restore();
}
